import { ChevronRightIcon } from '@heroicons/react/20/solid';
import classNames from 'classnames';
import { htmlToText } from 'html-to-text';

import { BreadcrumbProps } from './breadcrumb-types';

export default function Breadcrumb({ pages }: BreadcrumbProps) {
  return (
    <nav
      className="flex flex-row items-center rounded-lg bg-slate-50 p-4"
      aria-label="breadcrumb"
    >
      {pages.map((page, index) => (
        <li className="flex items-center overflow-ellipsis" key={page.name}>
          <a
            href={page.href}
            className={classNames(
              'breadcrumb-item mr-2 text-sm font-medium text-gray-500 hover:text-gray-700',
              { 'text-blue-600': page.current },
              { 'hover:text-blue-700': page.current },
            )}
            aria-current={page.current ? 'page' : undefined}
          >
            {htmlToText(page.name)}
          </a>
          {pages.length !== index + 1 && (
            <ChevronRightIcon
              className="h-5 w-5 flex-shrink-0 text-gray-400"
              aria-hidden="true"
            />
          )}
        </li>
      ))}
    </nav>
  );
}
